import { render } from "./BlackFridayPaywall.vue?vue&type=template&id=1f50f64b&scoped=true"
import script from "./BlackFridayPaywall.vue?vue&type=script&lang=js"
export * from "./BlackFridayPaywall.vue?vue&type=script&lang=js"

import "./BlackFridayPaywall.vue?vue&type=style&index=0&id=1f50f64b&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f50f64b"],['__file',"src/views/paywall/BlackFridayPaywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f50f64b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f50f64b', __exports__)) {
    console.log('reload')
    api.reload('1f50f64b', __exports__)
  }
  
  module.hot.accept("./BlackFridayPaywall.vue?vue&type=template&id=1f50f64b&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f50f64b', render)
  })

}


export default __exports__